module.exports = __webpack_public_path__ + "img/限时商品3.9fa62132.png";